import { createFileRoute } from "@tanstack/react-router";
import { motion } from "motion/react";
import { useSite } from "@/components/site/site-data";
const hero = { url: "/media/hero-2026-v3.png" };
import { ThemesGrid } from "@/components/site/ThemesGrid";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Conferința anuală InvesTenergy 2026 — Echilibrul Puterii în Energie" },
      {
        name: "description",
        content:
          "Dublu eveniment sub patronajul ANRE: Conferința anuală InvesTenergy (ediția a X-a) și Gala Specialiștilor din Energie (ediția a V-a), 6 octombrie 2026, Le Château, București.",
      },
      { property: "og:title", content: "Conferința anuală InvesTenergy 2026" },
      {
        property: "og:description",
        content: "Viziune. Investiții. Valoare Umană. 6 octombrie 2026, Le Château, București.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "/" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap",
      },
      { rel: "canonical", href: "/" },
    ],
  }),
  component: Home,
});

function Home() {
  const { blocks, themes } = useSite();

  return (
    <main className="min-h-screen bg-background">
      {/* HERO — posterul oficial */}
      <section className="relative isolate overflow-hidden bg-white">
        <div className="mx-auto max-w-[1500px] px-0 pt-5">
          <motion.img
            initial={{ opacity: 0, scale: 1.03 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease: "easeOut" }}
            src={hero.url}
            alt="Dublu eveniment InvesTenergy 2026 — Conferința anuală, ediția a X-a și Gala Specialiștilor din Energie, ediția a V-a, 6 octombrie 2026, Le Château"
            className="relative mx-auto block h-auto w-full"
          />
        </div>
        <div
          aria-hidden
          className="h-[5px] w-full"
          style={{ background: "linear-gradient(90deg, #198f31 0%, #00347e 100%)" }}
        />
      </section>


      {/* INTRO */}
      <section className="mx-auto max-w-6xl px-6 pt-14 pb-24">

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-xl leading-relaxed whitespace-pre-line text-foreground/90"
        >
          {blocks["home_intro"]?.body}
        </motion.p>
        <motion.blockquote
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-12 rounded-xl border-l-4 border-primary bg-secondary/60 p-8 font-display text-2xl leading-snug shadow-lift"
        >
          {blocks["home_quote"]?.body}
        </motion.blockquote>
      </section>

      {/* TEME */}
      <section className="bg-sand py-24">
        <div className="mx-auto max-w-6xl px-6">
          <ThemesGrid themes={themes} eyebrow="Ediția a X-a" />
        </div>
      </section>

      {/* GALA */}
      <section className="py-24">
        <div className="mx-auto max-w-6xl px-6">
          <div className="relative isolate">
            <div className="pointer-events-none absolute -top-24 left-1/2 -z-10 h-72 w-[36rem] -translate-x-1/2 rounded-full bg-gradient-energy opacity-15 blur-3xl" />
            <div className="text-center">
              <p className="font-display text-xs font-bold uppercase tracking-[0.35em] text-primary">
                Ediția a V-a
              </p>
              <h2 className="mt-3 text-4xl font-bold md:text-5xl">
                Gala Specialiștilor din Energie
              </h2>
              <span className="mx-auto mt-5 block h-px w-28 bg-gradient-energy" />
            </div>

            <motion.article
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6 }}
              className="group relative mt-14 overflow-hidden rounded-2xl border bg-card p-8 shadow-lift transition-colors duration-500 hover:bg-secondary/40 md:p-12"
            >
              <span className="absolute inset-y-0 left-0 w-[3px] origin-top scale-y-0 bg-gradient-energy transition-transform duration-500 group-hover:scale-y-100" />
              <p className="font-display text-2xl font-bold leading-snug text-primary md:text-3xl">
                Punem Oamenii din Energie în Lumină, la Gala InvesTenergy dedicată Specialiștilor.
              </p>
              <p className="mt-6 text-lg leading-relaxed text-foreground/90">
                Împreună cu invitații și partenerii InvesTenergy, premiem Specialiști merituoși
                pentru profesionalismul, dedicarea și performanțele lor, pentru munca de zi cu zi și
                contribuția lor la sectorul energetic.
              </p>
              <p className="mt-6 font-display text-xl font-semibold md:text-2xl">
                Respect și prețuire pentru toți Specialiștii din Energie!
              </p>
            </motion.article>
          </div>
        </div>
      </section>

    </main>
  );
}

